import type { ReactNode } from 'react';

export const symbol_roller_shades_closed: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M479.9-60q-24.9 0-42.4-17.57T420-120H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-180 110-180h50v-600q0-24.75 17.63-42.38Q195.25-840 220-840h520q24.75 0 42.38 17.62Q800-804.75 800-780v600h50q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H540q0 25-17.6 42.5T479.9-60ZM220-350h520v-430H220v430Zm0 170h230v-110H220v110Zm290 0h230v-110H510v110ZM220-780h520-520Z"
		/>
	</svg>
);
